
import { Card, CardContent } from "@/components/ui/card";
import { Users, Calendar, MessageCircle, Target, GraduationCap, School, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const AdvantagesList = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 bg-gradient-to-br from-brand-secondary/10 to-brand-primary/10">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Neler Sunuyoruz?</h2>

        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <Card className="shadow-lg hover:shadow-xl transition-shadow">
            <CardContent className="pt-6">
              <div className="flex items-start gap-4">
                <div className="h-10 w-10 rounded-full bg-brand-primary/20 flex items-center justify-center text-brand-primary">
                  <Users className="w-5 h-5" />
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2">Birebir Mentörlük</h4>
                  <p className="text-muted-foreground">Deneyimli mentörünüzle haftalık birebir görüşmeler yaparak hedeflerinize ulaşın.</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="shadow-lg hover:shadow-xl transition-shadow">
            <CardContent className="pt-6">
              <div className="flex items-start gap-4">
                <div className="h-10 w-10 rounded-full bg-brand-primary/20 flex items-center justify-center text-brand-primary">
                  <Calendar className="w-5 h-5" />
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2">Kişiselleştirilmiş Plan</h4>
                  <p className="text-muted-foreground">Size özel hazırlanmış günlük ve haftalık çalışma programı ile verimli çalışın.</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="shadow-lg hover:shadow-xl transition-shadow">
            <CardContent className="pt-6">
              <div className="flex items-start gap-4">
                <div className="h-10 w-10 rounded-full bg-brand-primary/20 flex items-center justify-center text-brand-primary">
                  <MessageCircle className="w-5 h-5" />
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2">Sürekli İletişim</h4>
                  <p className="text-muted-foreground">WhatsApp üzerinden 7/24 soru sorma imkanı ile takıldığınız yerde destek alın.</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="shadow-lg hover:shadow-xl transition-shadow">
            <CardContent className="pt-6">
              <div className="flex items-start gap-4">
                <div className="h-10 w-10 rounded-full bg-brand-primary/20 flex items-center justify-center text-brand-primary">
                  <Target className="w-5 h-5" />
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2">Motivasyon Desteği</h4>
                  <p className="text-muted-foreground">Sürekli motivasyon ve hedef odaklı rehberlik ile başarıya odaklanın.</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="shadow-lg hover:shadow-xl transition-shadow">
            <CardContent className="pt-6">
              <div className="flex items-start gap-4">
                <div className="h-10 w-10 rounded-full bg-brand-primary/20 flex items-center justify-center text-brand-primary">
                  <GraduationCap className="w-5 h-5" />
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2">Deneyim Aktarımı</h4>
                  <p className="text-muted-foreground">Bir derece öğrencisinin tecrübelerinden faydalanarak yolunuzu aydınlatın.</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="shadow-lg hover:shadow-xl transition-shadow">
            <CardContent className="pt-6">
              <div className="flex items-start gap-4">
                <div className="h-10 w-10 rounded-full bg-brand-primary/20 flex items-center justify-center text-brand-primary">
                  <School className="w-5 h-5" />
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2">Üniversite Hazırlık</h4>
                  <p className="text-muted-foreground">Üniversite hayatına adaptasyon için özel tavsiyeler ve yönlendirmeler alın.</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="text-center mt-8">
          <Button
            variant="default"
            size="lg"
            onClick={() => navigate('/koc-oner')}
            className="bg-brand-primary hover:bg-brand-primary/90 text-white"
          >
            Ücretsiz Ön Görüşme Planla
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
}; 
